
import http from '../http';

/**
 * 
 *
 * @export
 * @param {string} experimentGroupId
 * @returns
 */
export function getExperimentList(experimentGroupId) {
  return http.get(`/rocky/ssn/channel/diagram?channelId=${experimentGroupId}`);
};

/**
 * 
 *
 * @export
 * @param {string} baseVerificationId
 * @returns
 */
export function getBaseInterfaceInfo(verificationId) {
  return http.get(`rocky/sweep/base-init-data?verificationId=${verificationId}`);
}

/**
 * 
 *
 * @export
 * @param {string} channelId
 * @returns
 */
export function createExperiment(channelId) {
  return http.get(`/rocky/ssn/channel/diagram?channelId=${channelId}`);
}

// deleteExperiment
/**
 * 
 *
 * @export
 * @param {string} sweepId
 * @returns
 */
export function deleteExperiment(sweepId) {
  return http.get(`/rocky/ssn/channel/diagram?channelId=${sweepId}`);
}
/**
 * 
 *
 * @export
 * @param {string} baseVerificationId
 * @returns
 */
export function editExperiment(verificationId) {
  return http.get(`/rocky/ssn/channel/diagram?channelId=${verificationId}`);
}

/**
 * 
 *
 * @export
 * @param {string} deleteArr
 * @returns
 */
export function deleteExperimentByIds(deleteArr) {
  return http.get(`/rocky/ssn/channel/diagram?channelId=${deleteArr}`);
}

/**
 * sweeping simulation
 * 2021.11.17
 * params: { experimentIds }
 */
export function runSweeping({ experimentIds }) {
  return http.post(`/rocky/ssn/channel/sweep/run`, {
    experimentIds
  })
}

// getExperimentResult
/**
 * 
 *
 * @export
 * @param {string} sweepId
 * @param {*} option verification_json/
 * 
 * @returns
 */
export function getExperimentResult({ verificationId, signalGroup, option, type, signal, componentName }) {
  // if (signal) {
  return http.get(`/rocky/ssn/channel/sweep/result?verificationId=${verificationId}&option=${option}&signalGroup=${signalGroup}&type=${type}&signal=${signal}&componentName=${componentName}`);
  // } else {
  //   return http.get(`/rocky/ssn/channel/sweep/result?verificationId=${verificationId}&option=${option}&signalGroup=${signalGroup}&type=${type}`);
  // }
}

export function getPicExperimentResult({ verificationId, signalGroup, option, type, signal, componentName }) {
  return http.get(`/rocky/ssn/channel/sweep/result?verificationId=${verificationId}&option=${option}&signalGroup=${signalGroup}&type=${type}&signal=${signal}&componentName=${componentName}`, {
    responseType: 'arraybuffer'
  });

}

export function getExperimentMarginResult({ verificationIds, type, signalGroup }) {
  return http.post(`/rocky/ssn/channel/sweep/result/margin?type=${type}&signalGroup=${signalGroup}`, verificationIds);
}

export function getExperimentAdjustResult({ verificationId, signalGroup }) {
  return http.get(`/rocky/ssn/channel/sweep/result/adjusted/exist?verificationId=${verificationId}&signalGroup=${signalGroup}`);
}